export const EMPLOYEE_FORM_NAMES = {
  GENERAL: "general",
  COMPANY: "company",
  SYSTEM: "system",
  FILES: "files",
  EXTENDED: "extended",
  ACTIVITY: "activity",
}

/**
 * Provided by the create page only: the Arbeitszeitmodell list the new employee starts on, prefilled
 * with the Standardmodell and sent after `POST /user`. The Unternehmens-relevant tab edits it in place of
 * an employee's saved history, which does not exist yet.
 *
 * A reactive `{ assignments, flushPending, hasPendingInput }`: the tab puts the assignment block's two
 * functions on it, so the page's save takes over a row still open in the block's editor and leaving the
 * page asks about one.
 */
export const NEW_EMPLOYEE_WORK_TIME_MODELS = Symbol("lew:new-employee-work-time-models")
